/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/*
import * as React from 'react';
import { FunctionComponent, ReactNode } from 'react';
 */
import React, { FunctionComponent, ReactNode } from 'react';
import { ITableRowViewProps } from './table-row';

interface ICellType {
    tag: string;
    children?: ReactNode;
  }

type cellType = 'td' | 'th';

export const CellComponent: FunctionComponent<ICellType> = ({
    tag,
    children = null
  }) => {
    const Tag = tag as cellType;
    return (
      <Tag>
        <span>
         {children}
        </span>
      </Tag>
    );
  };

export default (props: ITableRowViewProps) => {
    const cells = props.config.cellItems;
    const cellTag = props.config.isHeader? 'th': 'td';

    return (
        cells?.map((cell, i) =>
            (
                <CellComponent tag={cellTag} key={`${i}_${cellTag}`}>
                    {cell.cellLink ? <a href={cell.cellLink}>{cell.cellContent}</a> : cell.cellContent}
                </CellComponent>
            )
        )
    );
};
